export const CONSENT_COOKIE_NAME = 'js360_consent_v1';
export const CONSENT_POLICY_VERSION = 'v1';
export const CONSENT_DURATION_DAYS = 365;
export const CONSENT_CHANGED_EVENT = 'js360:consent-changed';

const getCookie = (name) => {
  const prefix = `${name}=`;
  const cookie = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));
  return cookie ? cookie.slice(prefix.length) : null;
};

const deleteCookie = (name, domain) => {
  const domainPart = domain ? `;domain=${domain}` : '';
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainPart};SameSite=Lax`;
};

export const clearCookieEverywhere = (name) => {
  const hostname = window.location.hostname;
  const domains = [undefined, hostname, `.${hostname}`];
  const parentDomain = hostname.split('.').slice(-2).join('.');
  if (parentDomain && parentDomain !== hostname) {
    domains.push(parentDomain, `.${parentDomain}`);
  }
  domains.forEach((domain) => deleteCookie(name, domain));
};

export const clearConsentCookie = () => {
  clearCookieEverywhere(CONSENT_COOKIE_NAME);
};

export const getStoredConsent = () => {
  const rawConsent = getCookie(CONSENT_COOKIE_NAME);
  if (!rawConsent) return null;

  try {
    const consent = JSON.parse(decodeURIComponent(rawConsent));
    const expiry = consent.expires || consent.expires_at;
    if (consent.version !== CONSENT_POLICY_VERSION || !expiry || new Date(expiry) <= new Date()) {
      clearConsentCookie();
      return null;
    }

    return {
      version: consent.version,
      strictly_necessary: true,
      analytics: consent.analytics === true,
      marketing: consent.marketing === true,
      timestamp: consent.timestamp,
      expires: expiry,
    };
  } catch {
    clearConsentCookie();
    return null;
  }
};

export const setStoredConsent = (preferences) => {
  const timestamp = preferences.timestamp || new Date().toISOString();
  const expires = preferences.expires
    || preferences.expires_at
    || new Date(Date.now() + CONSENT_DURATION_DAYS * 24 * 60 * 60 * 1000).toISOString();
  const consent = {
    version: CONSENT_POLICY_VERSION,
    strictly_necessary: true,
    analytics: preferences.analytics === true,
    marketing: preferences.marketing === true,
    timestamp,
    expires,
  };
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${CONSENT_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(consent))};expires=${new Date(expires).toUTCString()};path=/;SameSite=Lax${secure}`;
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: consent }));
  return consent;
};

export const hasConsent = (category) => getStoredConsent()?.[category] === true;
